import { usePrefectureDashboardData } from '@/hooks/usePrefectureDashboardData'

const PrefectureGenerationStats = () => {
  const { data, isLoading, error } = usePrefectureDashboardData()

  if (isLoading) {
    return <div className="bg-white p-6 rounded-lg shadow animate-pulse">読み込み中...</div>
  }

  if (error || !data) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-800">データの読み込みに失敗しました</p>
      </div>
    )
  }

  const { generationStats } = data

  return (
    <div className="bg-white p-6 rounded-lg shadow">
      <h2 className="text-xl font-semibold mb-4">世代別統計</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {generationStats.map((stat) => (
          <div key={stat.generation} className="border rounded-lg p-4">
            <h3 className="font-semibold mb-3">{stat.generation}</h3>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between">
                <span>勝利:</span>
                <span className="font-medium">{stat.wins}</span>
              </div>
              <div className="flex justify-between">
                <span>敗戦:</span>
                <span className="font-medium">{stat.losses}</span>
              </div>
              <div className="flex justify-between">
                <span>PK:</span>
                <span className="font-medium">{stat.draws}</span>
              </div>
              <div className="flex justify-between">
                <span>勝率:</span>
                <span className="font-medium">{stat.winRate.toFixed(1)}%</span>
              </div>
              <div className="flex justify-between">
                <span>平均得点:</span>
                <span className="font-medium">{stat.averageGoalsPerMatch.toFixed(2)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default PrefectureGenerationStats

